import { searchParamsToFirstValueObject } from './searchParams'

/**
 * Utility to preserve URL parameters when navigating between pages.
 * Duplicate keys keep the first value so a CTA code is not replaced by the
 * query string Webflow appends (`source=LilyLime&source=LilyLim`).
 */
export const preserveUrlParams = (targetPath: string, paramsToPreserve?: string[]): string => {
  const currentParams = searchParamsToFirstValueObject(new URLSearchParams(window.location.search))
  const newUrl = new URL(targetPath, window.location.origin)

  if (paramsToPreserve) {
    // If specific parameters are provided, only preserve those
    paramsToPreserve.forEach((param) => {
      const value = currentParams[param]
      if (value) {
        newUrl.searchParams.set(param, value)
      }
    })
  } else {
    // By default, preserve ALL URL parameters (first value per key)
    Object.entries(currentParams).forEach(([key, value]) => {
      newUrl.searchParams.set(key, value)
    })
  }

  return newUrl.pathname + newUrl.search
}

/**
 * Get the current URL parameters as an object
 */
export const getCurrentUrlParams = (): Record<string, string> => {
  return searchParamsToFirstValueObject(new URLSearchParams(window.location.search))
}
